module.exports = __webpack_public_path__ + "img/et.a2fe3910.svg";